var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeOccupiedFemaleMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 19.5,
    width: 63,
    height: 19,
    rx: 9.5,
    transform: "rotate(180 63.5 19.5)",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_643)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 19.5,
    width: 63,
    height: 19,
    rx: 9.5,
    transform: "rotate(180 63.5 19.5)",
    stroke: "#1CADE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8699,
    y: 34.412,
    width: 55.0175,
    height: 48,
    transform: "rotate(-162.746 24.8699 34.412)",
    fill: "#ED6F8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeOccupiedFemaleMale);
export default __webpack_public_path__ + "static/media/free-occupied-female-male.872b462ddd9cf0e0785d081fbeae9ea7.svg";
export { ForwardRef as ReactComponent };